export const ACTIVITY_OPTIONS = [
  { value: "-", label: "- (rem)" },
  { value: "+", label: "+ (r)" },
  { value: "&", label: "& (r+r)" },
  { value: "m", label: "m (mat)" },
  { value: "i", label: "i (install)" },
  { value: "r", label: "r (d+r)" },
];
